import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetIndicadoresUseCase } from "../../../presentation/useCases/read/get_all_indicadores_use_case";

import { TercIndicadores } from "../../models/terc_indicadores";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

export class GetAllIndicadoresUseCase
  extends BasePaginatedUseCase<TercIndicadores>
  implements IGetIndicadoresUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {
    super();
  }

  async getAllIndicadores(): Promise<TercIndicadores> {

    const response = await this.repository.getAllIndicadores();
    return response;
  }
}
